import Drawer from './drawer'

export default class SidebarMenuSection {
  constructor(container) {
    this.element = container;
    this.sidebarDrawer = new Drawer(container);
  }

  onUnload() {
    this.sidebarDrawer.destroy();
  }
  onSelect() {
    this.sidebarDrawer.open();
  }
  onDeselect() {
    this.sidebarDrawer.close();
  }
}